import { useModuleLicense } from '../../hooks/useModuleLicense';

/**
 * Who may use the inductions admin pages. Seats, never RBAC roles:
 *   assessor      farm_jobs supervisor/admin, or vehicles creator/admin
 *   pack manager  timesheet hr
 * Mirrors the server's canAssess / canManagePack; the server is the real gate.
 */
export function useInductionSeats() {
  const jobs = useModuleLicense('farm_jobs', ['supervisor', 'admin']);
  const vehicles = useModuleLicense('vehicles', ['creator', 'admin']);
  const hr = useModuleLicense('timesheet', 'hr');
  const canAssess = jobs.hasAccess || vehicles.hasAccess;
  const canManagePack = hr.hasAccess;
  return {
    loading: jobs.loading || vehicles.loading || hr.loading,
    canAssess,
    canManagePack,
    hasAccess: canAssess || canManagePack,
  };
}
